import styled from 'styled-components';
import { secondaryFont } from 'components/mixins/typography';
import { transparentize } from 'utils/color';
import { Text, ShapedIcon } from 'components/common';
import media from 'components/mixins/media';

type RemainingAttemptsProps = {
  hasOneRemainingAttempt: boolean;
};

function getBorderColor(props: any) {
  return props.hasOneRemainingAttempt
    ? transparentize(props.theme.colors.mainColor, 0.3)
    : transparentize(props.theme.colors.textColor, 0.3);
}

export const RemainingAttemptsWrapper = styled.div.attrs((props: RemainingAttemptsProps) => ({
  hasOneRemainingAttempt: props.hasOneRemainingAttempt
}))<RemainingAttemptsProps>`
  border: solid 1px ${props => getBorderColor(props)};
  border-radius: 4px;
  display: flex;
  background-color: ${props =>
    props.hasOneRemainingAttempt
      ? transparentize(props.theme.colors.mainColor, 0.1)
      : transparentize(props.theme.colors.textColor, 0.02)};
  padding: 8px;
  align-items: center;
`;

export const InfoIcon = styled(ShapedIcon).attrs((props: RemainingAttemptsProps) => ({
  hasOneRemainingAttempt: props.hasOneRemainingAttempt
}))<RemainingAttemptsProps>`
  border: solid 1px ${props => getBorderColor(props)};
  .icon {
    font-size: 8px;
    margin: 0px;
  }
`;

export const RemainingAttemptsBlockText = styled(Text).attrs({
  'data-test': 'remaining-attempts-info'
})`
  ${secondaryFont};
  font-size: 10px;
  font-weight: 600;
  text-align: center;
  padding-left: 10px;
  padding-right: 10px;
  color: ${props => transparentize(props.theme.colors.textColor, 0.8)};
  text-align: left;
  ${media.mobile`
    line-height: 15px !important;
  `};
`;
